<template>
  <el-drawer
    :visible.sync="drawerVisible"
    :direction="'rtl'"
    :size="drawerSize"
    :before-close="handleClose"
    custom-class="notes-drawer"
    :z-index="9999"
  >
    <div class="notes-drawer__content">
      <div class="notes-drawer__header">
        <h4 class="notes-drawer__course">{{ courseName }}</h4>
        <p class="notes-drawer__class">{{ className }}</p>
      </div>

      <template v-if="!showEdit">
        <div class="notes-list">
          <div class="notes-list__actions">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-plus"
              @click="handleAddNote()"
            >
              {{ $t('note.button.add') }}
            </el-button>
          </div>

          <el-table
            :data="noteList"
            class="notes-list__table"
            :empty-text="$t('note.message.noNotes')"
            stripe
          >
            <el-table-column
              :label="$t('note.column.timestamp')"
              :width="isMobile ? '90' : '120'"
            >
              <template slot-scope="scope">
                <a
                  href="#"
                  class="notes-list__time-link"
                  @click.prevent="changeCurrentTime(scope.row.recordNoteTime)"
                >
                  <i class="fa fa-clock-o" v-if="!isMobile"></i>
                  {{ scope.row.recordNoteTime | secConvertTime }}
                </a>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('note.column.title')"
              prop="recordNoteTitle"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
              v-if="!isMobile"
              :label="$t('note.column.updateTime')"
              width="160"
            >
              <template slot-scope="scope">
                {{ scope.row.modifyDate | toTaipei | moment('YYYY/MM/DD HH:mm') }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('note.column.action')"
              :width="isMobile ? '80' : '120'"
              align="center"
            >
              <template slot-scope="scope">
                <div class="notes-list__actions-cell">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    circle
                    @click="handleAddNote(scope.$index)"
                  >
                  </el-button>
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    circle
                    @click="handleDelNote(scope.$index)"
                  >
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <template v-else>
        <div class="notes-form">
          <el-form
            :model="userNoteForm"
            label-position="top"
            :rules="userNoteRules"
            ref="userNoteForm"
            class="notes-form__container"
            @submit.prevent.native
          >
            <!-- 標題摘要 -->
            <el-form-item
              :label="$t('note.form.titleSummary')"
              prop="recordNoteTitle"
              required
            >
              <el-input
                :placeholder="$t('note.form.titleSummary')"
                type="text"
                v-model="userNoteForm.recordNoteTitle"
                maxlength="20"
                show-word-limit
              />
            </el-form-item>

            <!-- 筆記內容 -->
            <el-form-item
              :label="$t('note.form.content')"
              prop="recordNoteContent"
              required
            >
              <el-input
                type="textarea"
                v-model="userNoteForm.recordNoteContent"
                :rows="12"
                :placeholder="$t('note.form.content')"
              />
            </el-form-item>

            <!-- 時間戳記 -->
            <div class="notes-form__timestamp">
              <span class="notes-form__timestamp-label">
                {{ $t('note.form.timestamp') }}:
                <strong>{{ userNoteForm.recordNoteTime | secConvertTime }}</strong>
              </span>
              <el-button
                type="info"
                size="small"
                icon="el-icon-time"
                @click="changeRecordNoteTime()"
              >
                {{ $t('note.button.getCurrentTime') }}
              </el-button>
            </div>

            <!-- 送出按鈕 -->
            <div class="notes-form__actions">
              <el-button
                size="medium"
                @click="showEdit = false"
              >
                {{ $t('note.button.backToList') }}
              </el-button>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-check"
                @click="handleSaveNote"
              >
                {{ $t('note.button.save') }}
              </el-button>
            </div>
          </el-form>
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
// import { VueEditor } from 'vue2-editor';
import {
  GetRecordNotes,
  DeleteRecordNoteById,
  SaveRecordNoteById,
  GetRecordNoteById,
} from '@/api/MemberRecordApi';

export default {
  // 筆記清單、顯示筆記列表、
  props: ['code', 'showModel', 'course', 'classItem', 'videoTime'],
  // components: {
  //   VueEditor,
  // },
  data() {
    return {
      // 編輯器選項
      customToolbar: [
        ['bold', 'italic', 'underline'], // 粗體、斜體、底線
        [{ list: 'ordered' }, { list: 'bullet' }], // 清單
        [{ color: [] }, { background: [] }], //  字體顏色
        ['clean'], // 清除格式
      ],
      // 抽屜顯示狀態
      drawerVisible: false,
      // 筆記表單
      userNoteForm: {
        id: 0, // int:編號,新增=0
        classCode: '', // 課程代碼
        recordNoteTitle: '', // string:標題(20字)
        recordNoteContent: '', // string:html內文(不限制)
        recordNoteTime: 0, // int:時間戳(秒數)
      },
      // 檢查輸入的值規則
      userNoteRules: {
        recordNoteTitle: [
          { required: true, message: this.$t('validation.titleRequired'), trigger: 'blur' },
          { max: 20, message: this.$t('validation.titleMaxLength') },
        ],
        recordNoteContent: [{ required: true, message: this.$t('validation.contentRequired'), trigger: 'blur' }],
      },
      // 筆記清單
      noteList: [],
      // 顯示筆記視窗 (props)
      nodeOpenList: this.showModel,
      // 課程名稱 (props)
      courseName: this.course,
      className: this.classItem,
      // 課程相關資訊 (props)
      classCode: this.code,
      // 目前影片時間 (props)
      videoCurrentTime: this.videoTime,
      // 編輯視窗
      showEdit: false,
      // 編輯中的筆記index
      modifyNoteIndex: -1,
    };
  },
  computed: {
    drawerTitle() {
      return this.showEdit ? this.$t('note.title.edit') : this.$t('note.title.list');
    },
    drawerSize() {
      const width = window.innerWidth;
      if (width <= 480) return '100%'; // 手機版全螢幕
      if (width <= 768) return '85%'; // 小平板
      if (width <= 992) return '70%'; // 平板
      if (width <= 1200) return '50%'; // 小桌機
      return '40%'; // 大桌機 (不全螢幕)
    },
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  methods: {
    // 關閉筆記列表
    handleClose() {
      this.showEdit = false;
      this.drawerVisible = false;
      this.$emit('update:showModel', 0);
    },
    // 新增筆記
    handleAddNote(index = -1) {
      this.modifyNoteIndex = -1;
      this.userNoteForm.id = 0;
      this.userNoteForm.classCode = this.classCode;
      this.userNoteForm.recordNoteTitle = '';
      this.userNoteForm.recordNoteContent = '';
      this.userNoteForm.recordNoteTime = this.videoCurrentTime;
      if (index >= 0) {
        this.handleGetRecordNote(this.noteList[index].id);
        this.modifyNoteIndex = index;
      } else {
        this.$emit('pauseVideo');
      }
      this.showEdit = true;
    },
    // 刪除筆記
    handleDelNote(index) {
      const { id, recordNoteTitle } = this.noteList[index];
      this.$confirm(this.$t('note.message.deleteConfirm', { title: recordNoteTitle }), this.$t('common.dialog.title'), {
        confirmButtonText: this.$t('common.button.confirm'),
        cancelButtonText: this.$t('common.button.cancel'),
        type: 'warning',
      })
        .then(() => {
          DeleteRecordNoteById({ id }).then((response) => {
            if (response.data.statusCode === 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('note.message.deleteSuccess'),
              });
              this.noteList.splice(index, 1);
              this.$emit('changeNoetCount', this.noteList.length);
            } else this.$router.replace('/error').catch();
          });
        })
        .catch(() => {});
    },
    // 儲存筆記
    handleSaveNote() {
      this.$refs.userNoteForm.validate((valid) => {
        if (valid) {
          SaveRecordNoteById(this.userNoteForm).then((response) => {
            if (response.data.statusCode === 0) {
              const action = this.userNoteForm.id === 0 ? this.$t('note.action.add') : this.$t('note.action.edit');
              const msg = this.$t('note.message.saveSuccess', { action });
              if (this.userNoteForm.id === 0) {
                this.noteList.push({ ...response.data.data });
                this.userNoteForm.id = response.data.data.id;
                this.modifyNoteIndex = this.noteList.length - 1;
              } else {
                this.noteList.splice(this.modifyNoteIndex, 1, { ...response.data.data });
              }
              this.noteList = this._.sortBy(this.noteList, ['sort']);
              // this.noteList.sort((a, b) => a.sort > b.sort);
              this.$message({
                showClose: true,
                type: 'success',
                message: msg,
              });
              this.$emit('changeNoetCount', this.noteList.length);
            }
          });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('common.message.fillAllFields'),
          });
        }
      });
    },
    // 取得筆記列表
    async handleGetRecordNotes() {
      const { classCode } = this;
      const postData = {
        pageIndex: 1,
        pageSize: 9999,
        data: {
          classCode,
        },
      };
      await GetRecordNotes(postData).then((response) => {
        if (response.data.statusCode === 0) {
          const { data } = response.data;
          this.noteList = data;
        }
      });
    },
    // 取得筆記 by id
    handleGetRecordNote(id) {
      GetRecordNoteById({ id }).then((response) => {
        if (response.data.statusCode === 0) {
          this.userNoteForm = { ...response.data.data };
        }
      });
    },
    // 改變目前影片時間
    changeCurrentTime(time) {
      this.$emit('changeCurrentTime', time);
    },
    // 改變時間戳記
    changeRecordNoteTime() {
      this.$confirm(this.$t('note.message.timestampConfirm'), this.$t('common.dialog.title'), {
        confirmButtonText: this.$t('common.button.confirm'),
        cancelButtonText: this.$t('common.button.cancel'),
        type: 'warning',
      })
        .then(() => {
          this.userNoteForm.recordNoteTime = this.videoCurrentTime;
        })
        .catch(() => {});
    },
  },
  watch: {
    code(val) {
      if (val !== '') {
        this.classCode = val;
      }
    },
    course(val) {
      this.courseName = val;
    },
    classItem(val) {
      this.className = val;
    },
    showModel(val) {
      this.nodeOpenList = val;
    },
    async nodeOpenList(val) {
      if (val > 0) {
        if (this.className === '') {
          this.$message({
            showClose: true,
            type: 'warning',
            message: this.$t('note.message.selectClassFirst'),
          });
          this.$emit('update:showModel', 0);
        } else {
          await this.handleGetRecordNotes();
          this.drawerVisible = true;
          if (val > 1) this.handleAddNote();
          else this.showEdit = false;
        }
      } else {
        this.drawerVisible = false;
        this.showEdit = false;
      }
    },
    videoTime(val) {
      this.videoCurrentTime = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.notes-drawer__content {
  padding: 0 20px 20px;
  height: 100%;
  overflow-y: auto;
}

.notes-drawer__header {
  padding: 16px 0;
  border-bottom: 1px solid var(--border-color-light, #EBEEF5);
  margin-bottom: 20px;
}

.notes-drawer__course {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 8px 0;
  text-align: center;
}

.notes-drawer__class {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
  text-align: center;
}

/deep/ .ql-toolbar {
  background: white;
}

/deep/ .ql-editor {
  background: white;
}
</style>

<style lang="scss">
@import '~@/assets/scss/_variables.scss';

.notes-drawer {
  .el-drawer__header {
    padding: 20px;
    margin-bottom: 0;
    border-bottom: 1px solid var(--border-color-light, #EBEEF5);
    background-color: var(--background-base, #F5F7FA);
    z-index: 1101 !important; // 修正被 Header 覆蓋的問題

    .el-drawer__title {
      font-size: 18px;
      font-weight: 600;
      color: var(--text-primary);
    }
  }

  .el-drawer__body {
    padding: 0;
  }

  .el-drawer__close-btn {
    font-size: 24px;
    color: var(--text-regular);

    &:hover {
      color: var(--primary-color);
    }
  }
}

// 筆記列表區塊
.notes-list {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px);
  gap: 16px;

  &__actions {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 12px;
  }

  &__table {
    flex: 1;
    overflow: auto;

    // 自定義 el-table 樣式
    .el-table {
      font-size: 14px;

      th {
        background-color: var(--background-base, #F5F7FA);
        color: var(--text-color-regular, #606266);
        font-weight: 500;
        padding: 12px 0;
      }

      td {
        padding: 12px 0;
      }

      .el-table__row {
        transition: background-color 0.2s;

        &:hover {
          background-color: var(--primary-light-color, #dcf1fa);
        }
      }
    }
  }

  &__time-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--primary-color, #00ABEB);
    cursor: pointer;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #0088cc;
      text-decoration: underline;
    }

    i {
      font-size: 14px;
    }
  }

  &__actions-cell {
    display: flex;
    gap: 8px;
    justify-content: center;
  }
}

// 筆記表單區塊
.notes-form {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px);
  padding: 20px;

  &__container {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .el-form-item__label {
      font-weight: 500;
      color: var(--text-color-regular, #606266);
      padding-bottom: 8px;
    }

    .el-input__inner,
    .el-textarea__inner {
      border-radius: 4px;
      border-color: var(--border-color-base, #DCDFE6);
      transition: border-color 0.2s;

      &:focus {
        border-color: var(--primary-color, #00ABEB);
      }
    }

    .el-textarea__inner {
      resize: none;
      font-family: inherit;
      line-height: 1.6;
    }
  }

  &__timestamp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background-color: var(--background-base, #F5F7FA);
    border-radius: 4px;
    gap: 16px;

    &-label {
      font-size: 14px;
      color: var(--text-color-regular, #606266);

      strong {
        color: var(--primary-color, #00ABEB);
        font-weight: 600;
        margin-left: 8px;
      }
    }
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
    margin-top: auto;
    border-top: 1px solid var(--border-color-base, #DCDFE6);
  }
}

// 響應式設計 - 平板 (≤992px)
@media screen and (max-width: 992px) {
  .notes-list {
    padding: 18px;

    &__table {
      .el-table {
        th,
        td {
          padding: 11px 0;
        }
      }
    }
  }

  .notes-form {
    padding: 18px;

    &__container {
      .el-textarea__inner {
        font-size: 14px;
      }
    }
  }
}

// 響應式設計 - 小平板/大手機 (≤768px)
@media screen and (max-width: 768px) {
  .notes-drawer {
    .el-drawer__header {
      padding: 16px;
    }
  }

  .notes-list {
    padding: 16px;
    height: calc(100vh - 180px);

    &__actions {
      padding-bottom: 10px;

      .el-button {
        font-size: 13px;
        padding: 9px 15px;
      }
    }

    &__table {
      .el-table {
        font-size: 13px;

        th,
        td {
          padding: 10px 4px;
        }

        th {
          font-size: 12px;
        }
      }
    }

    &__time-link {
      font-size: 13px;
      gap: 4px;

      i {
        font-size: 12px;
      }
    }

    &__actions-cell {
      gap: 6px;

      .el-button {
        width: 28px;
        height: 28px;
        padding: 6px;

        i {
          font-size: 12px;
        }
      }
    }
  }

  .notes-form {
    padding: 16px;
    height: calc(100vh - 180px);

    &__container {
      gap: 14px;

      .el-form-item__label {
        font-size: 13px;
        padding-bottom: 6px;
      }

      .el-input__inner {
        font-size: 14px;
        padding: 10px 12px;
      }

      .el-textarea__inner {
        font-size: 14px;
        padding: 10px 12px;
      }
    }

    &__timestamp {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      padding: 10px 14px;

      &-label {
        font-size: 13px;

        strong {
          margin-left: 6px;
        }
      }

      .el-button {
        width: 100%;
      }
    }

    &__actions {
      flex-direction: column;
      gap: 10px;
      padding-top: 14px;

      .el-button {
        width: 100%;
        padding: 11px 20px;
      }
    }
  }
}

// 響應式設計 - 手機 (≤480px)
@media screen and (max-width: 480px) {
  .notes-drawer {
    .el-drawer__header {
      padding: 14px;
    }
  }

  .notes-drawer__header {
    padding: 12px 14px !important;
  }

  .notes-drawer__course {
    font-size: 16px !important;
    margin-bottom: 6px !important;
  }

  .notes-drawer__class {
    font-size: 13px !important;
  }

  .notes-list {
    padding: 12px;
    height: calc(100vh - 140px);
    gap: 12px;

    &__actions {
      .el-button {
        font-size: 12px;
        padding: 8px 12px;

        i {
          font-size: 12px;
        }
      }
    }

    &__table {
      .el-table {
        font-size: 12px;

        th,
        td {
          padding: 8px 2px;
        }

        th {
          font-size: 11px;
        }
      }
    }

    &__time-link {
      font-size: 12px;
      gap: 3px;
    }

    &__actions-cell {
      flex-direction: column;
      gap: 4px;

      .el-button {
        width: 26px;
        height: 26px;
        padding: 5px;

        i {
          font-size: 11px;
        }
      }
    }
  }

  .notes-form {
    padding: 12px;
    height: calc(100vh - 140px);

    &__container {
      gap: 12px;

      .el-form-item__label {
        font-size: 12px;
        padding-bottom: 6px;
      }

      .el-input__inner {
        font-size: 13px;
        padding: 8px 10px;
      }

      .el-textarea__inner {
        font-size: 13px;
        padding: 8px 10px;
        line-height: 1.5;
      }
    }

    &__timestamp {
      padding: 8px 12px;
      gap: 8px;

      &-label {
        font-size: 12px;

        strong {
          display: block;
          margin-left: 0;
          margin-top: 2px;
        }
      }

      .el-button {
        font-size: 12px;
        padding: 8px 12px;
      }
    }

    &__actions {
      gap: 8px;
      padding-top: 12px;

      .el-button {
        padding: 10px 16px;
        font-size: 13px;
      }
    }
  }
}

// 響應式設計 - 小手機 (≤360px)
@media screen and (max-width: 360px) {
  .notes-list {
    padding: 10px;

    &__table {
      .el-table {
        font-size: 11px;

        th {
          font-size: 10px;
        }
      }
    }

    &__time-link {
      font-size: 11px;
    }
  }

  .notes-form {
    padding: 10px;

    &__container {
      gap: 10px;

      .el-form-item__label {
        font-size: 11px;
      }

      .el-input__inner,
      .el-textarea__inner {
        font-size: 12px;
      }
    }

    &__timestamp {
      padding: 8px 10px;

      &-label {
        font-size: 11px;
      }

      .el-button {
        font-size: 11px;
        padding: 6px 10px;
      }
    }

    &__actions {
      .el-button {
        padding: 9px 14px;
        font-size: 12px;
      }
    }
  }
}
</style>
